import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {PatientService} from '../../_services';
import {Category, Patient} from '../../_models';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-edit-abeille',
  templateUrl: './edit-abeille.component.html',
  styleUrls: ['./edit-abeille.component.scss']
})
export class EditAbeilleComponent implements OnInit {

    @Input() abeille: Patient;
    @Output() refreshEvent = new EventEmitter<string>();

    lastname = '';
    firstname = '';
    birthday = '';
    errors = [];

    abeilleForm = new FormGroup({
        lastname: new FormControl(''),
        firstname: new FormControl(''),
        birthday: new FormControl(''),
    });

    constructor(private patientService: PatientService) { }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {

        if (this.abeille) {
            this.abeilleForm = new FormGroup({
                lastname: new FormControl(this.abeille.lastName),
                firstname: new FormControl(this.abeille.firstName),
                birthday: new FormControl(this.abeille.birthday),
            });
        }
    }

    checkAbeilleInfos() {

        this.errors = [];
        let isOK = true;

        if (!this.abeilleForm.value.lastname) {
          this.errors[`lastname`] = true;
          isOK = false;
        }
        if (!this.abeilleForm.value.firstname) {
          this.errors[`firstname`] = true;
          isOK = false;
        }
        if (!this.abeilleForm.value.birthday) {
          this.errors[`birthday`] = true;
          isOK = false;
        }

        return isOK;

    }

    onSubmit() {
        if (!this.checkAbeilleInfos()) {
            return;
        }

        this.abeille.lastName = this.abeilleForm.value.lastname;
        this.abeille.firstName = this.abeilleForm.value.firstname;
        this.abeille.birthday = this.abeilleForm.value.birthday;

        this.patientService.update(this.abeille).pipe(first()).subscribe(result => {
            this.abeilleForm.reset();
            this.refreshEvent.next();

        });
    }
}
